import { render, staticRenderFns } from "./TimeInForceField.vue?vue&type=template&id=45823c55&scoped=true"
import script from "./TimeInForceField.vue?vue&type=script&lang=js"
export * from "./TimeInForceField.vue?vue&type=script&lang=js"
import style0 from "./TimeInForceField.vue?vue&type=style&index=0&id=45823c55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45823c55",
  null
  
)

export default component.exports